import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";

export function useForgotPassword(): (email: string, turnstileToken?: string) => Promise<ApiPayload> {
  const forgotPassword = useCallback(async (email: string, turnstileToken?: string): Promise<ApiPayload> => {
    const response = await apiClient.forgotPassword(email, turnstileToken);

    if (!response.success) {
      throw new Error(response.message ?? `unexpectedError`);
    }

    return response;
  }, []);

  return forgotPassword;
}
